/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'nhs/pricing': {
    width: 23,
    height: 23,
    viewBox: '0 0 23 23',
    data: '<path pid="0" d="M11.263.136L0 0l.135 11.263L11.872 23 23 11.872 11.263.136zM1.455 10.688l-.067-9.301 9.301.067 10.384 10.418-9.202 9.2L1.455 10.689z" _fill="#000"/><path pid="1" d="M5.547 5.412l-.068.067c-1.285 1.286-1.285 3.382.034 4.702a3.28 3.28 0 002.3.946c.879 0 1.724-.338 2.368-.946a3.347 3.347 0 000-4.702C8.93 4.195 6.832 4.16 5.547 5.412zM9.2 9.201c-.371.371-.879.574-1.386.574a1.974 1.974 0 01-1.387-.574c-.778-.745-.778-1.962-.034-2.74l.034-.034a1.94 1.94 0 012.773 0c.372.372.575.88.575 1.387 0 .506-.203 1.014-.575 1.387z" _fill="#000"/>'
  }
})
